import { configureStore } from "@reduxjs/toolkit";
import { ThunkDispatch } from "redux-thunk";
import authReducer from "./slices/authSlice";
import fieldMappingReducer from "./slices/fieldMappingSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    fieldMapping: fieldMappingReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunkDispatch = ThunkDispatch<RootState, unknown, any>;

export default store;
